export default {
    baseStyle: {
        container: {
            display: 'flex',
            alignItems: 'center'
        },
        label: {
            width: 'full',
            fontSize: '14px'
        },
        control: {
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'gray.200',
            borderRadius: '3px',

            _checked: {
                backgroundColor: 'white',
                borderColor: 'gray.200',
                position: 'relative',

                _before: {
                    content: '""',
                    display: 'block',
                    width: '6px',
                    height: '6px',
                    borderRadius: '30%',
                    backgroundColor: 'black',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                },

                _hover: {
                    backgroundColor: 'white',
                    borderColor: 'gray.200'
                }
            },
            _hover: {
                borderColor: 'gray.200'
            },
            _focus: {
                boxShadow: 'none',
                backgroundColor: 'white',
                borderColor: 'gray.200'
            }
        }
    },

    sizes: {
        md: {
            control: {
                width: '14px',
                height: '14px',
                _invalid: {
                    borderColor: 'gray.200'
                }
            },
            label: {marginLeft: 3, fontSize: '14px'}
        }
    }
}
